<h2 class="header">Boligtyper</h2>

<div class="container">
    <ul>
        <li class="check-box all" (click)="selectAll()">
            <div class="checkbox-icon" [class.selected]="allSelected()"></div>
            <label>Alle</label>
        </li>
        @for (dwellingType of filterForm(); track $index) {
        <li class="check-box" (click)="toggleSelected(dwellingType().value())">
            <div class="checkbox-icon" [class.selected]="dwellingType.selected().value()"></div>
            <div class="estate-icon {{ dwellingType.iconClass().value() }}"></div>
            <label> {{ dwellingType.label().value() }} </label>
        </li>
        }
    </ul>
</div>